export enum RelationSublistConfigKey {
  ACTIVITY_PERSON = 'ActivityPerson',
  ACTIVITY_COMPANY = 'ActivityCompany',
  COMPANY_PERSON = 'CompanyPerson',
  PERSON_COMPANY = 'PersonCompany',
}

export enum RelationFilterKeySrc {
  ACTIVITY = 'activity',
  COMPANY = 'company',
  PERSON = 'person',
}

export enum RelationFilterKeyDist {
  CONTACT_ENTITY = 'contactEntity',
}

export enum RelationFilterKeySearch {
  CONTACT_SEARCH = 'contact_search',
  COMPANY_SEARCH = 'company_search',
  PERSON_SEARCH = 'person_search',
}

export enum RelationFilterValueDist {
  COMPANY = 'Company',
  PERSON = 'Person',
}

export enum RelationGetAttribute {
  CONTACT = 'contact',
  COMPANY = 'company',
  PERSON = 'person',
}

export enum RelationCreateKey {
  ACTIVITY = 'activity',
  CONTACT = 'contact',
  COMPANY = 'company',
  PERSON = 'person',
}
